import { Effect } from "../../../redux/types/effect.type";
import { EffectActionsObservable } from "../../../redux/types/effect-actions-observable.type";
import { catchError, filter, ignoreElements, map, mergeMap, tap } from "rxjs/operators";
import { isActionType } from "../../../redux/action.functions";
import { AuthActions } from "../../auth/store/auth.actions";
import * as actions from "./users.actions";
import * as executionBriefListActions from "../../../redux/actions/executionBriefListActions";
import { UsersActions } from "./users.actions";
import { UsersSearchForm } from "../types/users-search-form.interface";
import * as usersSearchService from "../services/users-search.service";
import { of } from "rxjs";

const searchUsers: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(UsersActions.SearchUsers)),
    map((action) => action.payload),
    mergeMap((form: UsersSearchForm) =>
      usersSearchService.searchUsers(form).pipe(
        map((results) => actions.searchUsersSuccess(results)),
        catchError((error) => of(actions.searchUsersFailure(error)))
      )
    )
  );

const fetchAllUsersOnLogin: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(AuthActions.AuthenticateSuccess)),
    map(() => actions.fetchAllUsers())
  );

const fetchAllUsers: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(UsersActions.FetchAllUsers)),
    mergeMap(() =>
      usersSearchService.fetchAllUsers().pipe(
        map((users) => actions.fetchAllUsersSuccess(users)),
        catchError((error) => of(actions.fetchAllUsersFailure(error)))
      )
    )
  );

const getRegionOptions: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(AuthActions.AuthenticateSuccess)),
    map((action) => action.payload),
    tap(() => executionBriefListActions.getRegionOptions()()),
    ignoreElements()
  );

export const UsersEffects = [searchUsers, fetchAllUsersOnLogin, fetchAllUsers, getRegionOptions];
